import { Survey } from "./survey";
import { feedbackRequired, SURVEY_RESPONSE_OPTIONS_DISPLAY, SURVEY_RESPONSE_OPTIONS_TIPS } from "@inthraction/labels";

export class EventSurvey extends Survey {
  //TODO: get these out of this class
  public static feedbackRequired = feedbackRequired;
  public static SURVEY_RESPONSE_OPTIONS_DISPLAY = SURVEY_RESPONSE_OPTIONS_DISPLAY;
  public static SURVEY_RESPONSE_OPTIONS_TIPS = SURVEY_RESPONSE_OPTIONS_TIPS;
}
